export default function PhotoGallery() {
  const galleryImages = [
    {
      src: 'https://readdy.ai/api/search-image?query=Soft%20dreamy%20atmosphere%20with%20cherry%20blossoms%20and%20gentle%20spring%20sunlight%2C%20elegant%20minimalist%20composition%2C%20warm%20cream%20and%20blush%20pink%20tones%2C%20Japanese%20aesthetic%2C%20editorial%20photography%2C%20soft%20bokeh%20background&width=600&height=450&seq=gallery-1&orientation=landscape',
      alt: '三上悠亞寫真作品展示 春日櫻花',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Elegant%20indoor%20studio%20setting%20with%20warm%20golden%20hour%20lighting%2C%20minimalist%20cream%20backdrop%2C%20sophisticated%20fashion%20editorial%20style%2C%20soft%20rose%20and%20beige%20color%20palette%2C%20refined%20Japanese%20photography&width=600&height=450&seq=gallery-2&orientation=landscape',
      alt: '三上悠亞寫真作品展示 室內光影',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Ocean%20sunset%20scene%20with%20warm%20golden%20light%20reflecting%20on%20gentle%20waves%2C%20romantic%20seaside%20atmosphere%2C%20soft%20peach%20and%20cream%20tones%2C%20cinematic%20composition%2C%20editorial%20travel%20photography&width=600&height=450&seq=gallery-3&orientation=landscape',
      alt: '三上悠亞寫真作品展示 海邊夕陽',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Minimalist%20Japanese%20room%20with%20shoji%20screens%20and%20soft%20natural%20light%2C%20tatami%20mat%20floor%2C%20elegant%20serene%20atmosphere%2C%20warm%20beige%20and%20cream%20tones%2C%20traditional%20meets%20modern%20aesthetic%2C%20editorial%20interior%20photography&width=600&height=450&seq=gallery-4&orientation=landscape',
      alt: '三上悠亞寫真作品展示 和室光影',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Summer%20meadow%20with%20wildflowers%20in%20soft%20golden%20sunlight%2C%20dreamy%20romantic%20atmosphere%2C%20gentle%20breeze%20effect%2C%20warm%20cream%20and%20soft%20lavender%20tones%2C%20editorial%20nature%20photography%2C%20sophisticated%20composition&width=600&height=450&seq=gallery-5&orientation=landscape',
      alt: '三上悠亞寫真作品展示 夏日花園',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Cozy%20candlelit%20evening%20scene%20with%20warm%20ambient%20glow%2C%20elegant%20decor%20with%20rose%20petals%2C%20romantic%20intimate%20atmosphere%2C%20soft%20golden%20and%20cream%20tones%2C%20editorial%20lifestyle%20photography%2C%20sophisticated%20mood&width=600&height=450&seq=gallery-6&orientation=landscape',
      alt: '三上悠亞寫真作品展示 燭光之夜',
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-3">
            精彩寫真
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            寫真精選
          </h2>
        </div>
        <div className="relative">
          <div className="aspect-[16/9] rounded-lg overflow-hidden mb-4">
            <img
              src={galleryImages[activeIndex].src}
              alt={galleryImages[activeIndex].alt}
              className="w-full h-full object-cover transition-opacity duration-500"
            />
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
            {galleryImages.map((img, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`aspect-[4/3] rounded-md overflow-hidden border-2 transition-all duration-200 cursor-pointer ${
                  activeIndex === index ? 'border-primary-500 opacity-100' : 'border-transparent opacity-60 hover:opacity-80'
                }`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
          <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 flex justify-between px-2 pointer-events-none">
            <button
              onClick={() => setActiveIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1))}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 hover:bg-background-50 transition-colors duration-200 pointer-events-auto cursor-pointer"
              aria-label="上一張"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={() => setActiveIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1))}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 hover:bg-background-50 transition-colors duration-200 pointer-events-auto cursor-pointer"
              aria-label="下一張"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

import { useState } from 'react';